import { H1, H2 } from '#ui/H.tsx'
import { P } from '#ui/P.tsx'

export function ErrorBody({ error }: { error: Error }) {
  const stack = error?.stack
  const message = error?.message
  console.error(error)

  return (
    <>
      <H1 className={x => x('text-flag-5')}>Error: {message}</H1>
      {/* TODO: set this to be only on dev */}
      {(ENV.IS_DEV || ENV.IS_PROD || ENV.IS_STAGING) && stack ? (
        <>
          <H2>Stack trace:</H2>
          <div className='w-full overflow-scroll pb-5'>
            <pre className='text-xs'>
              {stack.replace(/\/Users\/antti\/web\/pagespeedlog\//gi, '')}
            </pre>
          </div>
        </>
      ) : null}
    </>
  )
}

export function RouteErrorBody(props: { error: any }) {
  return (
    <>
      <H1 className={x => x('text-flag-5')}>
        {props.error?.status} {props.error?.statusText}
      </H1>
      <P>{props.error?.data}</P>
    </>
  )
}

export function UnknownErrorBody() {
  return <H1 className={x => x('text-flag-5')}>Unknown Error</H1>
}
